<template>
    <App :isShow="true">
        <div class="row gx-sm-0 gx-md-5 px-3">
            <div class="v-col-sm-12 col-md-8 v-col-lg-9 px-4">
                <SubMenu @onSearch="onSearchHandle" :searchShow="true"/>
                <div  v-html="page.body"></div>
            </div>
            <div class="v-col-sm-12 col-md-4 v-col-lg-3">
                <RightSideBar />
            </div>
        </div>

    </App>
</template>

<script setup>

import App from "../Layouts/App.vue";
import RightSideBar from "../Components/RightSideBar.vue";
import SubMenu from "../Components/Share/SubMenu.vue";
import {Inertia} from "@inertiajs/inertia";
import {ref} from "vue";

const search = ref('');
const props = defineProps({
    page: Object,
});
async function onSearchHandle(newSearch) {
    search.value = newSearch;
    Inertia.visit('/search/news', {
        method: 'get',
        data: {
            search: newSearch,
        },
        preserveState: true,
        replace: true,
        only: ['countPosts','search','posts','slug'],
    });
}

</script>

<style scoped>
</style>
